import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReceiptsService {

  constructor(private http: HttpClient) { }

  async createReceipts(recibos: any) {
    console.log(recibos);
    const res = await this.http.post('https://${this.apiUrl}api/v1/recibos', recibos).toPromise();
    return res;
  }
}
